import { lazy, Suspense } from "react"
import { Outlet } from "react-router-dom"
import Equity from "../../pages/Equity"

const TermsAndConditions = lazy(() => import("../../pages/TermsAndConditions"))
const AppleLogin = lazy(() => import("../../pages/AppleLogin"))
const YourArea = lazy(() => import("../../pages/YourArea"))
const Concierge = lazy(() => import("../../pages/Concierge"))
const Files = lazy(() => import("../../pages/Files"))
const Finances = lazy(() => import("../../pages/Finances"))
const Comparables = lazy(() => import("../../pages/Comparables"))
const Home = lazy(() => import("../../pages/Home"))
const Notifications = lazy(() => import("../../pages/Notifications"))
const NumberVerification = lazy(() => import("../../pages/NumberVerification"))
const PropertyDetails = lazy(() => import("../../pages/PropertyDetails"))
const SignIn = lazy(() => import("../../pages/SignIn"))
const SpecialOffers = lazy(() => import("../../pages/SpecialOffers"))
const LandingPage = lazy(() => import("../../pages/LandingPage"))
const TestPushNotifications = lazy(() =>
  import("../../pages/TestPushNotifications")
)
const Menu = lazy(() => import("../../pages/Menu"))
const More = lazy(() => import("../../pages/More"))
const Profile = lazy(() => import("../../pages/Profile"))
const YourNotifications = lazy(() => import("../../pages/YourNotifications"))
const AboutUs = lazy(() => import("../../pages/AboutUs"))
const Gallery = lazy(() => import("../../pages/Gallery"))
const ErrorPage = lazy(() => import("../../pages/ErrorPage"))
const Alerts = lazy(() => import("../../pages/Alerts"))
const ExternalView = lazy(() => import("../../pages/ExternalView"))
const Warning = lazy(() => import("../../pages/Warning"))
const FacebookCallback = lazy(() => import("../../pages/FacebookCallback"))
const UserValuations = lazy(() => import("../../pages/UserValuations"))
const AppSettings = lazy(() => import("../../pages/AppSettings"))
const Language = lazy(() => import("../../pages/Language"))
const HomeEfficiency = lazy(() => import("../../pages/HomeEfficiency"))
const Security = lazy(() => import("../../pages/Security"))
const Insurance = lazy(() => import("../../pages/Insurance"))
const Listings = lazy(() => import("../../pages/Listings"))
const MobileWidgetInfo = lazy(() => import("../../components/MobileWidgetInfo"))

const routes = {
  root: {
    path: "",
    element: <Outlet />,
    exact: false,
    children: {
      default: {
        path: "",
        exact: true,
        element: (
          <Suspense>
            <LandingPage />
          </Suspense>
        ),
      },
      "sign-in": {
        path: "sign-in",
        exact: true,
        element: (
          <Suspense>
            <SignIn />
          </Suspense>
        ),
      },
      "number-verification": {
        path: "number-verification",
        exact: true,
        element: (
          <Suspense>
            <NumberVerification />
          </Suspense>
        ),
      },
      "user-valuations": {
        path: "user-valuations",
        exact: true,
        element: (
          <Suspense>
            <UserValuations />
          </Suspense>
        ),
      },
      "not-found": {
        path: "not-found",
        element: (
          <Suspense>
            <ErrorPage type="not-found" />
          </Suspense>
        ),
      },
    },
  },
  "main-shell": {
    path: "valuations/:valuationId",
    element: <Outlet />,
    exact: true,
    children: {
      default: {
        path: "",
        exact: true,
        element: (
          <Suspense>
            <LandingPage />
          </Suspense>
        ),
      },
      external: {
        path: "external",
        exact: true,
        element: (
          <Suspense>
            <ExternalView />
          </Suspense>
        ),
      },
      equity: {
        path: "finances/equity",
        exact: true,
        element: (
          <Suspense>
            <Equity />
          </Suspense>
        ),
      },
      home: {
        path: "home",
        exact: true,
        element: (
          <Suspense>
            <Home />
          </Suspense>
        ),
      },
      "sign-in": {
        path: "sign-in",
        exact: true,
        element: (
          <Suspense>
            <SignIn />
          </Suspense>
        ),
      },
      "number-verification": {
        path: "number-verification",
        exact: true,
        element: (
          <Suspense>
            <NumberVerification />
          </Suspense>
        ),
      },
      "apple-login": {
        path: "apple-login",
        exact: true,
        element: (
          <Suspense>
            <AppleLogin />
          </Suspense>
        ),
      },
      "special-offers": {
        path: "special-offers",
        exact: true,
        element: (
          <Suspense>
            <SpecialOffers />
          </Suspense>
        ),
      },
      concierge: {
        path: "concierge",
        exact: true,
        element: (
          <Suspense>
            <Concierge />
          </Suspense>
        ),
      },
      notifications: {
        path: "notifications",
        exact: true,
        element: (
          <Suspense>
            <Notifications />
          </Suspense>
        ),
      },
      "property-details": {
        path: "property-details",
        exact: true,
        element: (
          <Suspense>
            <PropertyDetails />
          </Suspense>
        ),
      },
      gallery: {
        path: "gallery",
        exact: true,
        element: (
          <Suspense>
            <Gallery />
          </Suspense>
        ),
      },
      "your-area": {
        path: "your-area",
        exact: true,
        element: (
          <Suspense>
            <YourArea />
          </Suspense>
        ),
      },
      finances: {
        path: "finances",
        exact: true,
        element: (
          <Suspense>
            <Finances />
          </Suspense>
        ),
      },
      comparables: {
        path: "finances/comparables",
        exact: true,
        element: (
          <Suspense>
            <Comparables />
          </Suspense>
        ),
      },
      listings: {
        path: "finances/listings",
        exact: true,
        element: (
          <Suspense>
            <Listings />
          </Suspense>
        ),
      },
      files: {
        path: "files",
        exact: true,
        element: (
          <Suspense>
            <Files />
          </Suspense>
        ),
      },
      alerts: {
        path: "alerts",
        exact: true,
        element: (
          <Suspense>
            <Alerts />
          </Suspense>
        ),
      },
      warnings: {
        path: "alerts/:id",
        exact: true,
        element: (
          <Suspense>
            <Warning />
          </Suspense>
        ),
      },
      "test-notifications": {
        path: "test-notifications",
        exact: true,
        element: (
          <Suspense>
            <TestPushNotifications />
          </Suspense>
        ),
      },
      menu: {
        path: "menu",
        exact: true,
        element: (
          <Suspense>
            <Menu />
          </Suspense>
        ),
      },
      more: {
        path: "more",
        exact: true,
        element: (
          <Suspense>
            <More />
          </Suspense>
        ),
      },
      "your-profile": {
        path: "your-profile",
        exact: true,
        element: (
          <Suspense>
            <Profile />
          </Suspense>
        ),
      },
      "your-notifications": {
        path: "your-notifications",
        exact: true,
        element: (
          <Suspense>
            <YourNotifications />
          </Suspense>
        ),
      },
      "about-us": {
        path: "about-us",
        exact: true,
        element: (
          <Suspense>
            <AboutUs />
          </Suspense>
        ),
      },
      "app-settings": {
        path: "app-settings",
        element: (
          <Suspense>
            <AppSettings />
          </Suspense>
        ),
      },
      language: {
        path: "language",
        element: (
          <Suspense>
            <Language />
          </Suspense>
        ),
      },
      "home-efficiency": {
        path: "home-efficiency",
        element: (
          <Suspense>
            <HomeEfficiency />
          </Suspense>
        ),
      },
      security: {
        path: "security",
        element: (
          <Suspense>
            <Security />
          </Suspense>
        ),
      },
      insurance: {
        path: "insurance",
        element: (
          <Suspense>
            <Insurance />
          </Suspense>
        ),
      },
      "not-found": {
        path: "not-found",
        element: (
          <Suspense>
            <ErrorPage type="not-found" />
          </Suspense>
        ),
      },
      "mobile-widget-info": {
        path: "more-info",
        exact: true,
        element: (
          <Suspense>
            <MobileWidgetInfo />
          </Suspense>
        ),
      }
    },
  },
  "facebook-callback": {
    path: "facebook-callback",
    exact: true,
    element: (
      <Suspense>
        <FacebookCallback />
      </Suspense>
    ),
  },
  "terms-and-conditions": {
    path: "/terms-and-conditions",
    exact: true,
    element: (
      <Suspense>
        <TermsAndConditions />
      </Suspense>
    ),
  },
}

export default routes
